import { createTheme } from '@mui/material/styles';

// Default Theme
export const defaultTheme = createTheme({
  palette: {
    grey: {
      50: '#fafafa',
      100: '#f5f5f5',
      200: '#eeeeee',
      300: '#e0e0e0',
      400: '#bdbdbd',
      500: '#9e9e9e',
      600: '#757575',
      700: '#616161',
      800: '#333333',
      900: '#212121',
      A100: '#d5d5d5',
      A200: '#aaaaaa',
      A400: '#303030',
      A700: '#616161',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
      border: '#F0F3F4', // ⚠️ custom key (see note below)
    },
    blue: {
      blue1: '#4A90E2',
      blue2: '#0070D2',
      blue3: '#2189F8',
      blue4: '#1589EE',
      blue5: '#3493F8',
      blue6: '#00215B',
      strongblue: '#106EBE',
      lightblue: '#BAD1E5',
    },
    common: {
      black: '#000000',
      white: '#FFFFFF',
      success: '#0ead4e',
      magenta: '#9647AA',
      bluegrey: '#95AEC5',
      red: '#E6492D',
    },
    light: {
      purple1: '#8390B8',
      purple2: 'rgba(131, 144, 184, 0.6)',
      red: '#F44647',
      lightgrey: '#F3F2F2',
      darkgrey: '#DDDBDA',
    },
    text: {
      primary: '#3E3F42',
      secondary: '#9EA0A5',
    },
  },
});

export default defaultTheme;
